import { IPick, IMatchup } from '@/store/modules/game/interfaces'
import { GetOUFantasyAspect, GetOUFantasyProjection } from '@/utils/GameUtils'

export interface ISelection {
  matchupId?: string;
  mode: string;
  pick?: IPick;
  vs?: IPick;
  msg?: string;
  ou?: number;
  oulabel?: string;
  invalid?: boolean;
  classic?: boolean;
}

export interface IPlaceRequest {
  fee: number,
  picks: ISelectionRequest[]
}

export interface ISelectionRequest {
  matchupId: string;
  matchupPosition: string;
}

export interface IPlaceResult {
  transaction?: number;
  draft?: object;
  errorCode?: number;
  errorList?: string[];
}

export function PickToSelection(matchup: IMatchup, pick: IPick, variant: string, classic: boolean): ISelection {
  const vs: IPick = pick.player.id === matchup.pickA.player.id ? matchup.pickB : matchup.pickA

  let selection = {
    matchupId: matchup.id,
    mode: GetOUFantasyAspect(matchup.pickB),
    pick: pick,
    vs: vs,
    classic: classic
  } as ISelection

  if (variant === 'ou') {
    selection['ou'] = GetOUFantasyProjection(matchup.pickB)
    selection['oulabel'] = pick.player.id === matchup.pickA.player.id ? 'over' : 'under'
  }

  return selection
}

export interface ILocationUpdate {
    altitude: number;
    latitude: number;
    longitude: number;
    accuracy: number;
    speed: number;
    timestamp: number;
}
